export default function ToggleTermExtraInfo() {
    const toggleButtons = document.querySelectorAll('.toggle-extra-info');

    if (toggleButtons.length === 0) return;

    toggleButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            const container = this.closest('.form__labels--text--extra-info');
            const content = container.querySelector('.extra-info-content');
            const preview = container.querySelector('.extra-info-preview');
            const textExpand = this.getAttribute('data-text-expand');
            const textCollapse = this.getAttribute('data-text-collapse');

            if (!content.classList.contains('is-expanded')) {
                content.classList.remove('is-collapsed');
                content.classList.add('is-expanded');
                preview.classList.add('is-hidden');
                this.textContent = textCollapse;
                this.setAttribute('aria-expanded', 'true');
            } else {
                content.classList.remove('is-expanded');
                content.classList.add('is-collapsed');
                preview.classList.remove('is-hidden');
                this.textContent = textExpand;
                this.setAttribute('aria-expanded', 'false');
            }
        });
    });
}
